import colors from "constants/colors";
import styled from "styled-components";

export const StyledHr = styled.hr`
  border-width: 0px;
  height: 3px;
  background-color: ${colors.gray};
  margin: 2px -6px;
`;
